// client/src/App.js

import React from "react";
import logo from "../logo.svg";
import { Link } from 'react-router-dom'; // Assuming you're using react-router-dom

import "../App.css";
import CommonContext from '../commonContext';
import { postCall } from '../utils/requests';
import {
  Box,
  FormControl,
  Select,
  FormLabel,
  Textarea,
  Checkbox,
  Input,
  Center,
  AbsoluteCenter,
  HStack,
  Flex,
  Button,
  useToast,
  InputGroup,
  InputRightElement,
  Image,
  Text,
} from '@chakra-ui/react';
import { IoMdArrowRoundBack } from "react-icons/io";
import { BsFillPersonFill } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";
import { AiFillLock } from "react-icons/ai";

function LoginPage() {
  const [data, setData] = React.useState(null);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const commonContext = React.useContext(CommonContext);
  const [show, setShow] = React.useState(false)
  const toast = useToast();

  React.useEffect(() => {

    commonContext.setCurrentPath("Login")
    commonContext.setCurrentPage("login")

  }, []);

  const toggleShow = () => setShow(!show)

  const login = async (e) => {
    if (e != null) {
      e.preventDefault()
    }
    console.log("login")

    if (!email) {
      toast({
        title: "Errore",
        description: "Inserisci un indirizzo email",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return
    }

    if (!password) {
      toast({
        title: "Errore",
        description: "Inserisci una password",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return
    }

    let response = await postCall("/login", {
      email: email,
      password: password,
      type: "admin"
    })


    if (response.status === "success") {


      toast({
        title: "Successo",
        description: "Login effettuato con successo",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "top"
      })

      localStorage.setItem('currentUser', JSON.stringify({ email: email, password: password }))
      /* navigate to / */
      window.location.href = "/"

    } else {

      let msg = "Credenziali errate";

      if (response.error === "154") {
        msg = "Tipo account non consentito";
      }

      toast({
        title: "Errore",
        description: msg,
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
    }
  }



  return (
    <Box p="4">

      <AbsoluteCenter w="100%" h="100%" >
        <Image h="100%" w="100%" src='./sfondo4_comp.webp' />
      </AbsoluteCenter>

      {/*    <header className="App-header">
        <h1>SempreDiCorsa</h1>
      </header> */}
      <div className="App-body">
        {/* Login form */}

        <AbsoluteCenter>
          <Box
            w="600px"
            shadow="lg"
            bg="blue.300"
            borderRadius="lg"
            p="40px">



            <Center w="100%" h="100px" >
              <Image h="100px" src='./logo_trans.png' />
            </Center>

            <Center w="100%" h="100px" >
              <Image h="100px" src='./textlogo.png' />
            </Center>

            <form onSubmit={login}>


              {/* <button type="submit">Upload</button> */}
              <FormControl id="categoryName">
                <Flex mt="20px" mb="8px">
                  <Center>
                    <HStack>
                      <AiFillLock color="teal" size="40"></AiFillLock>
                      <FormLabel mt="15px" fontSize={25} color="white">Email</FormLabel>
                    </HStack>
                  </Center>
                </Flex>
                <Input
                  color="black"
                  bg="white"
                  type="text"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <Flex mt="20px" mb="8px">
                  <Center>
                    <HStack>
                      <BsFillPersonFill color="teal" size="40"></BsFillPersonFill>
                      <FormLabel mt="15px" fontSize={25} color="white">Password</FormLabel>
                    </HStack>
                  </Center>
                </Flex>
                <InputGroup size='md'>
                  <Input
                    type={show ? "text" : "password"}
                    color="black"
                    bg="white"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <InputRightElement width='4.5rem'>
                    <Button h='1.75rem' size='sm' onClick={toggleShow}>
                      {show ? 'Nascondi' : 'Mostra'}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                <Center>
                  <Button
                    type="submit"
                    bg="blue.100"
                    color="teal.900"
                    h="50px"
                    w="150px"
                    shadow="lg"
                    mt="20px"
                    p="15px"
                    colorScheme='green'
                    variant='solid'
                    onClick={login}
                    fontSize={25}>
                    Accedi
                  </Button>
                </Center>
              </FormControl>
            </form>
            <Link to="/termsandconditions">
              <Center mt="8">
                <Text
                  fontSize={20}
                  color="black">
                  Termini e condizioni
                </Text>
              </Center>
            </Link>


          </Box>
        </AbsoluteCenter>
      </div>
    </Box>
  );
}

export default LoginPage;